export enum ProjectTypeGq {
  MULTI_PROJECT = 'MULTI_PROJECT',
  NORMAL_SEARCH = 'NORMAL_SEARCH',
  QUICK_SEARCH = 'QUICK_SEARCH',
}
